import type { UseMutationOptions } from "@tanstack/react-query"

import {
  type GraphQLDocument,
  graphqlRequest,
  type GraphQLResponseError,
} from "#Utils/graphqlClient"
import { useMutation } from "#Utils/react-query-client"

type MaybeVariables = Record<string, unknown> | undefined

type GraphQLMutationOptions<TData, TVariables, TContext = unknown> = Omit<
  UseMutationOptions<TData, GraphQLResponseError, TVariables, TContext>,
  "mutationFn"
> & {
  document: GraphQLDocument<TData, TVariables> | string
  operationName?: string
}

export const graphqlMutationOptions = <TData, TVariables = MaybeVariables, TContext = unknown>({
  document,
  operationName,
  ...options
}: GraphQLMutationOptions<TData, TVariables, TContext>) => {
  return {
    ...options,
    mutationFn: (variables: TVariables) =>
      graphqlRequest<TData, TVariables>({ document, variables, operationName }),
  }
}

export const useGraphqlMutation = <TData, TVariables = MaybeVariables, TContext = unknown>(
  options: GraphQLMutationOptions<TData, TVariables, TContext>,
) => {
  return useMutation(graphqlMutationOptions(options))
}
